import { Header, HeaderTitle } from '@/components/header';
import { Page, PageContent } from '@/components/layout';

export function Dashboard() {
  return (
    <Page>
      <Header>
        <HeaderTitle>Dashboard</HeaderTitle>
      </Header>
      <PageContent variant="column">
        <div className="flex h-full flex-col items-center justify-center text-muted-foreground">
          Content
        </div>
      </PageContent>
    </Page>
  );
}
